import React from "react";
import {
    NavLink
} from "react-router-dom";


const SearchNav = props => {
    const activeColor = window.location.hostname.includes("stoelting") ? '#5D6677' : '#1A458B';
    return (
        <nav className="row justify-content-center search-nav-container">
            <NavLink style={({ isActive }) => ({
                background: isActive ? activeColor : '#fff',
                color: isActive ? '#fff' : '#1A458B'
            })} className="search-tab col-lg-2" to={`/products?q=${props.q}`}>
                Products
            </NavLink>

            <NavLink style={({ isActive }) => ({
                background: isActive ? activeColor : '#fff',
                color: isActive ? '#fff' : '#1A458B'
            })} className="search-tab col-lg-2" to={`/documents?q=${props.q}`}>
                Documents
            </NavLink>


            <NavLink style={({ isActive }) => ({
                background: isActive ? activeColor : '#fff',
                color: isActive ? '#fff' : '#1A458B'
            })} className="search-tab col-lg-2" to={`/inspiration?q=${props.q}`}>
                Blog
            </NavLink>

            <NavLink style={({ isActive }) => ({
                background: isActive ? activeColor : '#fff',
                color: isActive ? '#fff' : '#1A458B'
            })} className="search-tab col-lg-2" to={`/videos?q=${props.q}`}>
                Videos
            </NavLink>

            <NavLink style={({ isActive }) => ({
                background: isActive ? activeColor : '#fff',
                color: isActive ? '#fff' : '#1A458B'
            })} className="search-tab col-lg-2" to={`/pages?q=${props.q}`}>
                Web Pages
            </NavLink>
        </nav>
    );
}

export default SearchNav;
